export default __webpack_public_path__ + "static/media/asdw.9a18dca3.png";